import React, { useMemo } from 'react';
import { Menu } from 'semantic-ui-react';
import {
    useChartStoreDataSources,
    useChartStoreActiveDataSourceTab,
    useChartStoreDataSourceActions,
} from '../../../../context';
import { groupBySchema, getIntersectedFields } from './utils';
import ConsolidatedFieldRow from './components/consolidatedFieldRow';

function ConsolidatedSidebar() {
    const dataSources = useChartStoreDataSources();
    const activeTab = useChartStoreActiveDataSourceTab();
    const { setActiveTab } = useChartStoreDataSourceActions();

    const activeSource = dataSources.find((s) => s.id === activeTab) ?? null;

    const schemaGroups = useMemo(() => groupBySchema(dataSources), [dataSources]);

    const activeSchemaName = activeSource?.schemaName ?? null;
    const activeSchemaSources = useMemo(
        () => (activeSchemaName ? schemaGroups.get(activeSchemaName) ?? [] : []),
        [activeSchemaName, schemaGroups],
    );

    const intersectedFields = useMemo(
        () => getIntersectedFields(activeSchemaSources),
        [activeSchemaSources],
    );

    const isSingleSchema = schemaGroups.size <= 1;

    return (
        <div className="chart-field-sidebar">
            {!isSingleSchema && (
                <Menu vertical fluid size="small" className="chart-field-sidebar__tabs">
                    {[...schemaGroups.entries()].map(([schemaName, sources]) => (
                        <Menu.Item
                            key={schemaName}
                            active={activeSchemaName === schemaName}
                            onClick={() => setActiveTab(sources[0].id)}
                            className="chart-field-sidebar__tab"
                        >
                            {schemaName}
                        </Menu.Item>
                    ))}
                </Menu>
            )}

            <div className="chart-field-sidebar__fields">
                {intersectedFields.length > 0 && (
                    <table>
                        <tbody>
                            {intersectedFields.map((field) => (
                                <ConsolidatedFieldRow
                                    key={field.commonFieldId}
                                    field={field}
                                    schemaSources={activeSchemaSources}
                                />
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default React.memo(ConsolidatedSidebar);
